import { Box, Menu, MenuItem, Typography } from '@mui/material';
import {
  // Route,
  List,
  Clock,
  MapIcon,
  Route,
  Store,
  TruckIcon} from "lucide-react";
import { LONG_HAUL_DEFAULT_SPAN_DAYS } from 'src/pages/LongHaul/spanDays';

import { LinkMenuItem } from './LinkMenuItem';

interface Props {
  dateMenuAnchor: HTMLElement | null;
  handleDateMenuClose: () => void;
  selectedDate: Date | null;
  /** 長距離配車の出し分け。ヘッダの配車計画メニューと同じ幹線輸送のフラグを使う */
  useTrunkTransportation: boolean;
}

export const LinkMenu = ({
  dateMenuAnchor,
  handleDateMenuClose,
  selectedDate,
  useTrunkTransportation,
}: Props) => {
  {/* 日付選択メニュー */}
  return (
    <Menu
      anchorEl={dateMenuAnchor}
      open={Boolean(dateMenuAnchor)}
      onClose={handleDateMenuClose}
      slotProps={{
        paper: {
          sx: {
            mt: 1,
            boxShadow: 3,
            borderRadius: 2,
            minWidth: 250,
            p: 0,
          }
        }
      }}
    >
      <MenuItem
        disabled
        sx={{
          opacity: 1,
          cursor: "default",
          "&:hover": { bgcolor: "transparent" }
        }}
      >
        <Typography variant="subtitle2" fontWeight="bold" color="primary.main">
          {selectedDate && `${selectedDate.getFullYear()}年${selectedDate.getMonth() + 1}月${selectedDate.getDate()}日`}
        </Typography>
      </MenuItem>
      <Box sx={{ px: 2, py: 1 }}>
        <Typography variant="caption" color="text.secondary">
          以下から選択してください
        </Typography>
      </Box>

      <LinkMenuItem
        path="shipment-orders"
        selectedDate={selectedDate}
        primaryText="案件一覧"
        secondaryText="伝票・配送指示を確認"
        icon={<List size={18} />}
      />

      <LinkMenuItem
        path="plans"
        selectedDate={selectedDate}
        primaryText="配車計画（マップ (旧)）"
        secondaryText="地図上で配車状況を確認"
        icon={<MapIcon size={18} />}
        endNotice
      />

      <LinkMenuItem
        path="map"
        selectedDate={selectedDate}
        primaryText="配車計画（マップ）"
        secondaryText="地図上で配車状況を確認"
        icon={<MapIcon size={18} />}
      />

      <LinkMenuItem
        path="timeline"
        selectedDate={selectedDate}
        primaryText="配車計画（タイムライン）"
        secondaryText="時間軸で配車スケジュールを確認"
        icon={<Clock size={18} />}
      />

      <LinkMenuItem
        path="convenience-dispatches"
        selectedDate={selectedDate}
        primaryText="配車計画（カード）"
        secondaryText="固定コース・当日配車を管理"
        icon={<Store size={18} />}
      />

      {/* 並び・アイコンはヘッダの配車計画メニューに合わせる（カードとレーン管理の間・
          トラックのアイコン）。既定のレンジだけが他画面と違い 7 日 */}
      {useTrunkTransportation && (
        <LinkMenuItem
          path="long-haul"
          selectedDate={selectedDate}
          primaryText="配車計画（長距離配車）"
          secondaryText="長距離の運行を確認"
          icon={<TruckIcon size={18} />}
          rangeDays={LONG_HAUL_DEFAULT_SPAN_DAYS}
        />
      )}

      <LinkMenuItem
        path="lanes"
        selectedDate={selectedDate}
        primaryText='レーン管理'
        secondaryText="車両割当・レーン設定を確認"
        icon={<Route size={18} />}
      />
    </Menu>
  );
};
